import React from 'react';
import {reduxForm} from 'redux-form';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import GridHelper from 'infrastructure/js/components/Grid/Utils/gridHelper';

import './qplsActivityLogViewGrid.scss';

class QplsActivityLogViewGrid extends React.PureComponent {

  filterConfig = [
    {fieldName: 'qplName', filterName: 'name', getOptions: true},
    {fieldName: 'qplVersion', filterName: 'versionName', getOptions: true},
    {fieldName: 'testName', filterName: 'testName', getOptions: true},
    {fieldName: 'setName', filterName: 'setName', getOptions: true},
    {fieldName: 'valueBeforeChange', filterName: 'valueBeforeChange', getOptions: true},
    {fieldName: 'valueAfterChange', filterName: 'valueAfterChange', getOptions: true},
    {fieldName: 'time.epochDateTime', filterName: 'fromDate'},
    {fieldName: 'username', filterName: 'reportedBy', getOptions: true},
  ];

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.qplsActivityLog.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [    //TODO: L QPL AL - handle field names, filters, sorting
      {
        fieldName: 'time.epochDateTime',
        title: this.labels.get('columns.time.title'),
        filterType: filterTypes.NONE, //filterTypes.DATE_SELECT,
        valueFormatter: (params) => {
          return (params.data && params.data.m_Time ? params.data.m_Time : '');
        },
        width: 165,
        columnOptions: {
          cellRenderer: 'agGroupCellRenderer',
          sort: 'desc',
          headerComponentParams: GridHelper.getDateFormatHeaderIcon(),
          valueGetter: (params) => {
            return params.data?.time?.epochDateTime;
          },
        }
      },
      {
        // fieldName: 'qplName',
        fieldName: 'qplName',
        title: this.labels.get('columns.qplName.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'name',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'qplVersion',
        title: this.labels.get('columns.qplVersion.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'versionName',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'testName',
        title: this.labels.get('columns.testName.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'testName',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'setName',
        title: this.labels.get('columns.setName.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'setName',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'valueBeforeChange',
        title: this.labels.get('columns.valueBeforeChange.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'valueBeforeChange',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'valueAfterChange',
        title: this.labels.get('columns.valueAfterChange.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'valueAfterChange',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'username',
        title: this.labels.get('columns.reportedBy.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'reportedBy',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        },
      },
    ]
  };

  render() {
    return (
      <div className="administration-view-grid qpls-activity-log-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_ACTIVITY_LOG}
              columnsConfig={this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={
                {
                  checkboxSelection: false
                }
              }
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'qplsActivityLogViewGrid'
  }
)(QplsActivityLogViewGrid);
